var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import styled from 'styled-components';
var sliderThumbStyles = function (props) { return ("\n  width: 15px;\n  height: 15px;\n  background: " + props.cor + ";\n  background-color: " + props.cor + ";\n  cursor: pointer;\n  -webkit-transition: .2s;\n  transition: opacity .2s;\n  border-radius: 10px;\n"); };
var Styles = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\ndisplay: flex;\nalign-items: center;\ncolor: #888;\nmargin-top: 2rem;\nmargin-bottom: 2rem;\n\n.slider {\n    flex: 1;\n    -webkit-appearance: none;\n    width: 100%;\n    height: 10px;\n    border-radius: 5px;\n    background: #efefef;\n    outline: none;\n\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      ", "      \n    }\n}\n\n"], ["\n\ndisplay: flex;\nalign-items: center;\ncolor: #888;\nmargin-top: 2rem;\nmargin-bottom: 2rem;\n\n.slider {\n    flex: 1;\n    -webkit-appearance: none;\n    width: 100%;\n    height: 10px;\n    border-radius: 5px;\n    background: #efefef;\n    outline: none;\n\n    &::-webkit-slider-thumb {\n      -webkit-appearance: none;\n      appearance: none;\n      ", "      \n    }\n}\n\n"])), function (props) { return sliderThumbStyles(props); });
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var value;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        value = e.target.value;
                        // usa o setState do pai (settado no contexto) para atualizar o valor
                        return [4 /*yield*/, this.props.contexto.setState((_a = {},
                                _a[this.props.nome] = parseFloat(value),
                                _a))];
                    case 1:
                        // usa o setState do pai (settado no contexto) para atualizar o valor
                        _b.sent();
                        if (!this.props.onChange) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.props.onChange(value)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    Slider.prototype.render = function () {
        return (React.createElement(Styles, { cor: this.props.cor },
            React.createElement("input", { type: "range", id: this.props.nome, name: this.props.nome, min: this.props.min, max: this.props.max, step: this.props.step, value: this.props.valor, className: "slider", onChange: this.onChange }),
            React.createElement("div", { className: "value" },
                "\u00A0 ",
                this.props.valor,
                this.props.formato)));
    };
    Slider.defaultProps = {
        cor: "#33C3F0;",
        step: 1,
        valor: 0,
    };
    return Slider;
}(Component));
export { Slider };
var templateObject_1;
